(() => {
  'use strict';
  // The theme editor can replace a section; never attach two owners/listeners.
  window.Q21StoreMotion?.dispose();
  const controller = new AbortController();
  const beams = new Map(), revealed = new Set();
  const root = document.documentElement;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const enabled = () => !reduced.matches && document.body.dataset.motionEnabled !== 'false';
  const beamObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target,isIntersecting}) => target.classList.toggle('q21-beam-visible', isIntersecting && enabled()));
  }, {threshold:0.01}) : null;
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target,isIntersecting}) => {
      if (!isIntersecting) return;
      if (enabled()) target.classList.add('q21-entered');
      revealObserver.unobserve(target);
    });
  }, {threshold:0.04}) : null;
  const release = host => {
    beamObserver?.unobserve(host);
    const decoration = beams.get(host);
    decoration?.edge.remove();
    decoration?.glow?.remove();
    beams.delete(host);
    host.classList.remove('q21-beam-host','q21-beam-visible','q21-beam-halo');
  };
  function refresh() {
    beams.forEach((_,host) => { if (!host.isConnected) release(host); });
    for (const target of revealed) if (!target.isConnected) { revealObserver?.unobserve(target); revealed.delete(target); }
    document.querySelectorAll('#finder, .store-master, .catalog-product-visual, .q21-backend-offer, .q21-license-description > summary, .q21-custom-description > [data-layer-description-toggle]').forEach(host => {
      if (beams.has(host)) return;
      const edge = document.createElement('span');
      edge.className='q21-beam-edge'; edge.setAttribute('aria-hidden','true');
      let glow = null;
      // Blur only the decorative perimeter, never the logo, copy, price or link.
      if (host.classList.contains('store-master') || host.classList.contains('q21-backend-offer') || host.matches('.q21-license-description > summary, .q21-custom-description > [data-layer-description-toggle]')) {
        host.classList.add('q21-beam-halo');
        glow = document.createElement('span');
        const ring = document.createElement('span');
        glow.className='q21-beam-glow'; glow.setAttribute('aria-hidden','true');
        ring.className='q21-beam-glow-ring'; glow.append(ring); host.append(glow);
      }
      host.classList.add('q21-beam-host'); host.append(edge); beams.set(host,{edge,glow});
      // No observer support: keep a static decorative edge, no perpetual motion.
      beamObserver?.observe(host);
    });
    document.querySelectorAll('[data-q21-reveal]').forEach((target,index) => {
      if (revealed.has(target)) return;
      revealed.add(target);
      target.style.setProperty('--q21-enter-delay', `${(index % 3) * 55}ms`);
      revealObserver?.observe(target);
    });
    sync();
  }
  function sync() {
    root.dataset.q21PageHidden=String(document.hidden);
    root.dataset.q21Motion=enabled()?'on':'off';
    if (!enabled()) beams.forEach((_,host)=>host.classList.remove('q21-beam-visible'));
  }
  const changed=()=>{sync();beams.forEach((_,host)=>{beamObserver?.unobserve(host);beamObserver?.observe(host);});};
  document.addEventListener('visibilitychange',sync,{signal:controller.signal});
  reduced.addEventListener('change',changed,{signal:controller.signal});
  document.addEventListener('shopify:section:load',refresh,{signal:controller.signal});
  document.addEventListener('shopify:section:unload',event=>{
    beams.forEach((_,host)=>{if(event.target.contains(host))release(host);});
    for(const target of revealed)if(event.target.contains(target)){revealObserver?.unobserve(target);revealed.delete(target);}
  },{signal:controller.signal});
  window.Q21StoreMotion={refresh,dispose(){controller.abort();beamObserver?.disconnect();revealObserver?.disconnect();beams.forEach((_,host)=>release(host));revealed.forEach(target=>{target.classList.remove('q21-entered');target.style.removeProperty('--q21-enter-delay');});revealed.clear();delete root.dataset.q21PageHidden;delete root.dataset.q21Motion;}};
  refresh();
})();
